export const ls_token = "user_token";
export const ls_proxy_token = "user_proxy_token";
export const ls_userInfo = "user_userinfo";
export const ls_comtyInfo = "user_comtyinfo";
export const ls_bId = "user_bId";
export const ls_orgInfo = "user_orginfo";
export const ls_comtyId = "user_comtyId";
export const ls_permissionList = "user_permissionList";
export const ls_isHaveOrgAuth = "isHaveOrgAuth";
export const ls_token_new = "user_token_new";
export const ls_comtyId_new = "user_comtyId_new";
export const ls_comtyId_token = "user_comtyId_token";
export const ls_comtyInfo_new = "user_comtyinfo_new";
export const ls_userInfo_new = "user_userinfo_new";
export const ls_permissionList_new = "user_permissionList_new";
